import Promotions, { ViewMode } from '../../ports-frontend/Promotions';
import MessageBus from '../../ports-frontend/MessageBus';

export async function startPromotionsFlow(viewMode: ViewMode) {
  await Promotions.startPromotions('basecamp-container', viewMode);
}

export async function promotionsWatcher({ callback }: { callback: Function }) {
  const unsubscribePromotionsDetails = await MessageBus.onSubscribe(
    ({
      payload: { promotionSlug, promotionLangCode },
    }: {
      payload: { promotionSlug: string; promotionLangCode: string };
    }) => {
      callback({
        type: 'PROMOTION_DETAILS_DISPLAYED',
        payload: {
          pageSlug: promotionSlug,
          promotionLangCode: promotionLangCode,
        },
      });
    },
    ['wh.common.event.ui.promotions.showDetails']
  );

  const unsubscribePromotionsList = await MessageBus.onSubscribe(
    ({
      payload: { promotionLangCode },
    }: {
      payload: { promotionLangCode: string };
    }) => {
      callback({
        type: 'PROMOTION_LIST_DISPLAYED',
        payload: {
          promotionLangCode,
        },
      });
    },
    ['wh.common.event.ui.promotions.showList']
  );

  const unsubscribePromotionsGameOpen = await MessageBus.onSubscribe(
    ({ payload }: { payload: { presentationCode: string } }) => {
      callback({
        type: 'PROMOTIONS_GAME_OPEN_CLICK',
        payload: {
          presentationCode: payload.presentationCode,
        },
      });
    },
    ['wh.common.event.ui.promotions.gameLaunch']
  );

  return () => {
    unsubscribePromotionsDetails();
    unsubscribePromotionsList();
    unsubscribePromotionsGameOpen();
  };
}

export async function showPromotionsList(locale: string) {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.promotions.showList',
    data: { promotionLangCode: locale },
  });
}

export async function showPromotionsDetails(slug: string, locale: string) {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.promotions.showDetails',
    data: { promotionSlug: slug, promotionLangCode: locale },
  });
}
